import { inject, Injectable } from '@angular/core';
import { KeyRequestsManagerService } from '@pages/key-requests/key-requests-manager.service';
import { KeyRequestFormData, KeyRequestSubmit, KeyRequestSubmitResult } from './key-request-form.config';
// import { HttpClient } from '@angular/common/http';
// import { firstValueFrom } from 'rxjs';
// import { environment } from 'src/environments/environment';

/*
Datos del formulario público de pedido de llave (AF298).
Hoy lee y escribe Firestore directo desde el navegador (KeyRequestsManagerService), igual que el registro de consorcistas
(decidido el 2026-10-13 para tener algo funcional; el riesgo está anotado en errores_pendientes).
Si se aprueba la propuesta "el formulario no toca Firestore", se cambia solo este service por la versión con function
(abajo, comentada): las pantallas no cambian.
El modo demo (datos de ejemplo con ?cod=demo-..., sin escribir nada) también quedó comentado, para volver a usarlo.
*/
@Injectable({
    providedIn: 'root',
})
export class KeyRequestFormService {
    private manager = inject(KeyRequestsManagerService);

    load(cod: string): Promise<KeyRequestFormData> {
        // if (this.isDemo(cod)) return this.demoLoad(cod);
        return this.manager.loadForm(cod);
    }

    submit(cod: string, data: KeyRequestSubmit): Promise<KeyRequestSubmitResult> {
        // if (this.isDemo(cod)) return this.demoSubmit(cod, data);
        return this.manager.submitForm(cod, data);
    }

    /* ---------- versión con function (propuesta pendiente): POST {backendUrl}/publicform ---------- */

    // private http = inject(HttpClient);
    // private endpoint = environment.backendUrl + '/publicform';
    //
    // async loadFromFunction(cod: string): Promise<KeyRequestFormData> {
    //     try {
    //         return await firstValueFrom(this.http.post<KeyRequestFormData>(this.endpoint, { type: 'keyRequest', action: 'load', cod }));
    //     } catch (error) {
    //         //un 4xx con estado conocido (link vencido, usado...) viene en el cuerpo del error
    //         const body = (error as any)?.error;
    //         if (body?.state) {
    //             return body as KeyRequestFormData;
    //         }
    //         throw error;
    //     }
    // }
    //
    // async submitToFunction(cod: string, data: KeyRequestSubmit): Promise<KeyRequestSubmitResult> {
    //     try {
    //         return await firstValueFrom(this.http.post<KeyRequestSubmitResult>(this.endpoint, { type: 'keyRequest', action: 'submit', cod, data }));
    //     } catch (error) {
    //         const body = (error as any)?.error;
    //         if (body && typeof body.success === 'boolean') {
    //             return body as KeyRequestSubmitResult;
    //         }
    //         return { success: false, error: 'INTERNAL_ERROR' };
    //     }
    // }

    /* ---------- modo demo (solo fuera de producción): /pedido-llave?cod=demo-<escenario> ---------- */

    // private isDemo(cod: string): boolean {
    //     return !environment.production && cod.startsWith('demo-');
    // }
    //
    // private async demoLoad(cod: string): Promise<KeyRequestFormData> {
    //     await new Promise(r => setTimeout(r, 400));
    //     const scenario = DEMO_SCENARIOS[cod];
    //     return scenario ? structuredClone(scenario) : { state: 'invalid' };
    // }
    //
    // private async demoSubmit(cod: string, data: KeyRequestSubmit): Promise<KeyRequestSubmitResult> {
    //     await new Promise(r => setTimeout(r, 600));
    //     console.info('[pedido-llave demo] se enviaría:', data);
    //     if (cod === 'demo-error-envio') {
    //         return { success: false, error: 'VALIDATION', message: 'El DNI no es válido' };
    //     }
    //     return { success: true };
    // }
}

// const DEMO_SCENARIOS: Record<string, KeyRequestFormData> = {
//     // una sola unidad, sin DNI ni contacto de emergencia, con otra persona registrada sin DNI
//     'demo-una': {
//         state: 'ok',
//         requester: { firstName: '[CLAUDE-TS] Ana', lastName: 'Demo' },
//         units: [{
//             consorcistaId: 'c1', consorcioId: 'k1', consorcioName: 'Edificio Demo', label: 'Piso 3 - Depto B',
//             occupancyRole: 'owner', hasDni: false, hasEmergencyContact: false,
//             members: [{ consorcistaId: 'c2', firstName: 'Juan', lastName: 'Demo', hasDni: false }],
//         }],
//     },
//     // dos unidades: una con todo cargado y sin otras personas, otra sin contacto de emergencia
//     'demo-varias': {
//         state: 'ok',
//         requester: { firstName: '[CLAUDE-TS] Luis', lastName: 'Demo' },
//         units: [
//             {
//                 consorcistaId: 'c3', consorcioId: 'k1', consorcioName: 'Edificio Demo', label: 'Torre A - Piso 1 - Depto 2',
//                 occupancyRole: 'tenant', hasDni: true, hasEmergencyContact: true, members: [],
//             },
//             {
//                 consorcistaId: 'c4', consorcioId: 'k2', consorcioName: 'Torres del Parque', label: 'Cochera 12',
//                 occupancyRole: 'owner', hasDni: true, hasEmergencyContact: false,
//                 members: [{ consorcistaId: 'c5', firstName: 'Marta', lastName: 'Demo', hasDni: true }],
//             },
//         ],
//     },
//     // como demo-varias, pero el agente ya mandó la unidad
//     'demo-preseleccion': {
//         state: 'ok',
//         requester: { firstName: '[CLAUDE-TS] Luis', lastName: 'Demo' },
//         preselectedConsorcistaId: 'c4',
//         units: [
//             {
//                 consorcistaId: 'c3', consorcioId: 'k1', consorcioName: 'Edificio Demo', label: 'Torre A - Piso 1 - Depto 2',
//                 occupancyRole: 'tenant', hasDni: true, hasEmergencyContact: true, members: [],
//             },
//             {
//                 consorcistaId: 'c4', consorcioId: 'k2', consorcioName: 'Torres del Parque', label: 'Cochera 12',
//                 occupancyRole: 'owner', hasDni: true, hasEmergencyContact: false,
//                 members: [{ consorcistaId: 'c5', firstName: 'Marta', lastName: 'Demo', hasDni: true }],
//             },
//         ],
//     },
//     // inmobiliaria: no puede pedir "para mí" y se pide el DNI de quien retira
//     'demo-inmobiliaria': {
//         state: 'ok',
//         requester: { firstName: '[CLAUDE-TS] Inmobiliaria Demo' },
//         units: [{
//             consorcistaId: 'c6', consorcioId: 'k1', consorcioName: 'Edificio Demo', label: 'Piso 5 - Depto A',
//             occupancyRole: 'realEstate', hasDni: false, hasEmergencyContact: true,
//             members: [{ consorcistaId: 'c7', firstName: 'Pedro', lastName: 'Inquilino', hasDni: false }],
//         }],
//     },
//     'demo-error-envio': {
//         state: 'ok',
//         requester: { firstName: '[CLAUDE-TS] Ana', lastName: 'Demo' },
//         units: [{
//             consorcistaId: 'c1', consorcioId: 'k1', consorcioName: 'Edificio Demo', label: 'Piso 3 - Depto B',
//             occupancyRole: 'owner', hasDni: true, hasEmergencyContact: true, members: [],
//         }],
//     },
//     'demo-vencido': { state: 'expired' },
//     'demo-usado': { state: 'used' },
//     'demo-invalido': { state: 'invalid' },
// };
